import { TweenMax } from 'gsap';
import { Container, Sprite, Texture } from 'pixi.js';
import { getGameSize, IGameSizeInfo } from '../../Config/Levels';
// import Rectangle = PIXI.Rectangle;
// import { createRect } from '../../Editor/EditorUtils';
// import app from '../../index';

export class ScreenBlur extends Container {
    // private blurSprite: Sprite;
    // private screenTexture: PIXI.Texture;
    private blur: PIXI.Sprite;

    constructor() {
        super();

        // Create a sprite with a white texture of 10x10 size, used for graphics and other things can not be destroyed.
        const c = new Sprite(Texture.WHITE);
        this.blur = c;
        this.addChild(c);

        // Applied a black tint to the sprite and set a default alpha.
        c.tint = 0;
        c.alpha = 0.5;

        // Stretches to fit to the game size.
        const gameSize: IGameSizeInfo = getGameSize();
        c.width = gameSize.gameWidth;
        c.height = gameSize.gameHeight;

        /*this.screenTexture = app.renderer.generateTexture(
            app.stage,
            PIXI.SCALE_MODES.NEAREST,
            1,
            new Rectangle(0, 0, gameSize.gameWidth, gameSize.gameHeight)
        );
        const s = new Sprite(this.screenTexture);
        s.scale.set(1 / gameSize.gameScale);
        s.filters = [new PIXI.filters.BlurFilter(5, 5, 1)];

        c.addChild(s); */

        // const overlay = createRect(
        //     new Rectangle(0, 0, gameSize.gameWidth, gameSize.gameHeight),
        //     0x000000,
        //     0x000000,
        //     1
        // );
        // overlay.alpha = 0.5;
        // c.addChild(overlay);

        // this.addChild(c);
        // this.blurSprite = s;
    }

    public destroyBlur() {
        // this.blurSprite.filters = [];
        // this.blurSprite.destroy();
        // PIXI.Texture.removeFromCache(this.screenTexture);
        // this.screenTexture.destroy();
        this.destroy();
    }

    public fade(a: number, ms: number) {
        TweenMax.to(this, ms / 1000, {
            alpha: a,
            onComplete: () => {
                this.destroyBlur();
            },
        });
    }

    public cacheBlur() {
        // this.blurSprite.filters = [new PIXI.filters.BlurFilter(15, 5, 1)];
        /*const cText = Core.INSTANCE.renderer.generateTexture(this.containerSprite);
        const d = new Sprite(cText);
        this.addChild(d);

        // this.blurSprite.filters = [];
        this.containerSprite.destroy(); */
        // this.containerSprite.cacheAsBitmap = true;
    }

    public resize(sizeInfo: IGameSizeInfo) {
        this.blur.width = sizeInfo.gameWidth;
        this.blur.height = sizeInfo.gameHeight;
    }
}
